<div tabindex="0" class="me-banners--card bg-secondary documents-card" *ngIf="data">
    <div class="me-banners--card__icon close-icon hidden">
        <i class="fal fa-times"></i>
    </div>
    <div class="me-banners--card__header">
        {{data.documentsTitle}}
    </div>

    <div *ngIf="data.image"
         class="me-banners--card__image align-content-center"
         [innerHTML]="data.image | storyblokImage:'stb-image'"></div>

    <div class="documents-card--wrapper" *ngIf="documents && documents.length > 0">
        <ng-container *ngFor="let document of documents">
            <div class="documents-card--wrapper--item">
                <div class="documents-card--wrapper--item--name">
                    <span class="col-xs-12 p-0 documents-card--wrapper--item--name name">
                        {{ document.original_file_name }}
                    </span>

                    <span class="col-xs-12 p-0 documents-card--wrapper--item--name info" *ngIf="document.size">
                            ({{getFileType(document.original_file_name)}}, {{ formatBytes(document.size) }})
                    </span>
                </div>
                <div class="documents-card--wrapper--item--button">
                    <button type="submit" [attr.aria-label]="'Download' | translate" class="btn btn--primary btn-download" (click)="download(document)">
                        <i class="fal fa-download"></i>
                    </button>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="me-banners--card__description">
        <div class="me-banners--card__content"
             *ngIf="documents.length"
             [innerHTML]="data.documentsInfo | storyblokRichtext">
        </div>

        <div class="me-banners--card__content empty"
             *ngIf="documents.length === 0"
             [innerHTML]="data.emptyText | storyblokRichtext">
        </div>
    </div>
    <div class="me-banners--card__footer">
        <div class="me-banners--card__button"
             *ngIf="data.button && data.button.length"
             [innerHTML]="data.button[0] | storyblokButton">
        </div>
    </div>
</div>
